import React from "react";
import Navbar from "./Navbar";
import RecurtBanner from "./RecurtBanner";
import BannerCount from "./BannerCount";
import WhySimpliRecruit from "./WhySmikiRecruit";
import Reviews from "../../Program/Reviews/Reviews";
import Faq from "../../Faq/Faq";
import OverView from "./OverView";
import LearnersProfile from "./LearnersProfile";
import ContactUs from "./ContactUs";
import Blogs from "./Blogs";

function Smikrecruit() {
  return (
    <>
      <Navbar />
      <div id="whyus" className="mt-10">
        <RecurtBanner />
        <BannerCount />
        <WhySimpliRecruit />
      </div>
 {/*      <div id="overviews">
        <OverView />
      </div> */}
      <div id="learners">
        <LearnersProfile />
      </div>
      <div id="blog">
        <Blogs />
      </div>
      <div id="testimonials">
        <Reviews />
      </div>
      <div id="faq">
        <Faq />
      </div>
      <ContactUs />
    </>
  );
}

export default Smikrecruit;
